define([
  'articles'
], (Articles) => {
  function findEmbeddedAnchor(placementOffset, belowFold) {
    const articles = Articles.findAll();
    const article = articles.sort((a, b) => {
      return a.offsetHeight > b.offsetHeight ? -1 : 1;
    })[0];

    placementOffset = (placementOffset / 100) || 0.5;

    if (article) {
      const articleHeight = article.offsetHeight;
      const articleWidth = article.offsetWidth;
      let children = article.getElementsByTagName('*');
      children = Array.prototype.slice.call(children);
      children = children.filter((node) => {
        if (!node) return false;
        if (node.offsetWidth < Math.min(500, articleWidth) && node.parentNode !== article) return false;
        if (belowFold && node.offsetTop < window.innerHeight + 5) return false;

        if (window.getComputedStyle) {
          let style = window.getComputedStyle(node, null);
          // Ignore inline elements
          if (style.getPropertyValue('display') === 'inline') return false;

          // Ignore floated elements
          if (['left', 'right'].indexOf(style.getPropertyValue('float')) >= 0) return false;

          let nextSibling = node.nextSibling;
          if (nextSibling) {
            // Ignore elements preceding headers
            if (['H1','H2','H3','H4','H5','H6'].indexOf(nextSibling.tagName) >= 0) return false;
          }

          let parentNode = node.parentNode;
          // Ignore elements with fixed or hidden parents, and ignore elements with a, lists, table, button parents
          while (parentNode && parentNode !== article) {
            let parentStyle = window.getComputedStyle(parentNode, null);
            if (parentStyle.getPropertyValue('position') === 'fixed') return false;
            if (parentStyle.getPropertyValue('display') === 'none') return false;
            if (parentStyle.getPropertyValue('visibility') === 'hidden') return false;
            if (['A', 'UL', 'OL', 'TABLE', 'BUTTON'].indexOf(parentNode.tagName) >= 0) return false;
            parentNode = parentNode.parentNode;
          }

          return true;
        } else {
          return false;
        }
      });

      if (children && children.length) {
        // Sort by closest to center of article
        children.sort((a, b) => {
          return Math.abs(a.offsetTop - (articleHeight * placementOffset)) < Math.abs(b.offsetTop - (articleHeight * placementOffset)) ? -1 : 1;
        });

        return children[0];
      }
    }

    return null;
  }

  function findManualAnchors(popupId, legacyEmbedCodes) {
    let nodeQuery = `[data-sumome-listbuilder-id="${popupId}"], [data-sumome-listbuilder-embed-id="${popupId}"]`;
    for (let i = 0; i < legacyEmbedCodes.length; i += 1) {
      var code = legacyEmbedCodes[i];
      nodeQuery += `, [data-sumome-listbuilder-id="${code}"], [data-sumome-listbuilder-embed-id="${code}"]`;
    }

    return document.querySelectorAll(nodeQuery);
  }

  function getManuallyEmbeddedIds() {
    const embedCodeIds = [];
    const elements = document.querySelectorAll('[data-sumome-listbuilder-id], [data-sumome-listbuilder-embed-id]');

    if (elements && elements.length) {
      for (let i = 0; i < elements.length; i++) {
        embedCodeIds.push(elements[i].getAttribute('data-sumome-listbuilder-id') || elements[i].getAttribute('data-sumome-listbuilder-embed-id'));
      }
    }

    return embedCodeIds;
  }

  return {
    findEmbeddedAnchor: findEmbeddedAnchor,
    findManualAnchors: findManualAnchors,
    getManuallyEmbeddedIds: getManuallyEmbeddedIds,
  };
});
